import * as i0 from "@angular/core";
export class SchoolLoginStore {
}
SchoolLoginStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SchoolLoginStore_Factory() { return new SchoolLoginStore(); }, token: SchoolLoginStore, providedIn: "root" });
export var SchoolLoginStoreKeys;
(function (SchoolLoginStoreKeys) {
})(SchoolLoginStoreKeys || (SchoolLoginStoreKeys = {}));
